import { t } from '@kanbios/ui';

/**
 * Santé (D25): Checkmk's checks read as health, not as a log. A known check
 * gets a French name; any other keeps its Checkmk name.
 */
/** The families themselves are the server's (D120: `family` of each check); here, their checks' French names. */
const NAMES: [RegExp, (m: RegExpMatchArray) => string][] = [
  [/^APT Updates$/i, () => t('health.names.apt')],
  [/^NTP Time$/i, () => t('health.names.ntp')],
  [/^CPU load$/i, () => t('health.names.cpuLoad')],
  [/^CPU utilization$/i, () => t('health.names.cpuUse')],
  [/^Memory$/i, () => t('health.names.memory')],
  [/^Uptime$/i, () => t('health.names.uptime')],
  [/^Disk IO SUMMARY$/i, () => t('health.names.diskIo')],
  [/^Filesystem (.+)$/i, m => t('health.names.filesystem', { mount: m[1]! })],
  [/^Interface (.+)$/i, m => t('health.names.interface', { name: m[1]! })],
  [/^Docker containers$/i, () => t('health.names.dockerContainers')],
  [/^Docker node info$/i, () => t('health.names.dockerNode')],
  [/^Docker disk usage - (.+)$/i, m => t('health.names.dockerDisk', { what: m[1]! })],
  [/^Check_MK$/i, () => t('health.names.cmkCollect')],
  [/^Check_MK Agent$/i, () => t('health.names.cmkAgent')],
  [/^Check_MK Discovery$/i, () => t('health.names.cmkDiscovery')],
  [/^Check_MK HW\/SW Inventory$/i, () => t('health.names.cmkInventory')],
  [/^Kanbios running$/i, () => t('health.names.running')],
  [/^Systemd Service Summary$/i, () => t('health.names.systemd')],
  [/^TCP Connections$/i, () => t('health.names.tcp')],
];

/** The check's name as people read it; null when Checkmk's name is the only one. */
export function frenchName(name: string): string | null {
  for (const [pattern, name_] of NAMES) {
    const m = name.match(pattern);
    if (m) return name_(m);
  }
  return null;
}
